import { render, staticRenderFns } from "./ActiveBacklogModel.vue?vue&type=template&id=7a7a8331&"
import script from "./ActiveBacklogModel.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklogModel.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBacklogModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports